const menus1 = [
  {
    id: '1548965010455572481',
    parentId: '0',
    code: '1',
    name: '首页',
    alias: '1',
    path: '/penalize/home',
    source: 'iconfont  ui-amy-archives',
    sort: 40,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '',
    isDeleted: 0
  },
  {
    id: '1548962010455572481',
    parentId: '0',
    code: '1',
    name: '填报系统',
    alias: '1',
    path: '',
    source: 'iconfont  ui-amy-archives',
    sort: 40,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '',
    isDeleted: 0,
    children: [
      {
        id: '1548962146388770817',
        parentId: '1548962010455572481',
        code: '1',
        name: '案件填报',
        alias: '案件填报',
        path: '/fill/in/punish',
        source: 'leftfont  leftfontzfth',
        sort: 1,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1548962146388770317',
        parentId: '1548962010455572481',
        code: '1',
        name: '案件查看',
        alias: '案件查看',
        path: '/fill/in/punish/view',
        source: 'basicfont  iconviewSelfAssessmentDetail',
        sort: 1
      },
      {
        id: '1548962854676692993',
        parentId: '1548962010455572481',
        code: '2',
        name: '企业档案',
        alias: '企业档案',
        path: '/register/archive',
        source: 'leftfont  leftfontzhongdianqiyejiankong',
        sort: 2,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '4',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1548962854671692993',
        parentId: '1548962010455572481',
        code: '2',
        name: '案件申请',
        alias: '案件申请',
        path: '/penalize/applyCorrect',
        source: 'leftfont  leftfontzhongdianqiyejiankong',
        sort: 2,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '4',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },

      {
        id: '1548962854671693993',
        parentId: '1548962010455572481',
        code: '2',
        name: '案件审核',
        alias: '案件审核',
        path: '/penalize/approvalCase',
        source: 'leftfont  leftfontzhongdianqiyejiankong',
        sort: 2,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '4',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1548963081240412161',
        parentId: '1548962010455572481',
        code: '6',
        name: '使用帮助',
        alias: '使用帮助',
        path: '6',
        source: 'iconfont  ui-amy-help',
        sort: 6,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      }
    ],
    hasChildren: false,
    parentName: '',
    categoryName: '',
    actionName: '',
    isOpenName: ''
  },
  {
    id: '1555087252571807746',
    parentId: '0',
    code: '1',
    name: '智能化分析',
    alias: '智能化分析',
    path: '',
    source: 'leftfont  leftfonthuanjingjiance',
    sort: 50,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '环保部系统',
    isDeleted: 0,
    children: [
      {
        id: '1552224318153781249',
        parentId: '1555087252571807746',
        code: 'penalize_info_query',
        name: '信息查询',
        alias: 'penalize_info_query',
        path: '/',
        source: 'iconfont  ui-amy-book',
        sort: 8,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        children: [
          {
            id: '1552221636968787970',
            parentId: '1552224318153781249',
            code: 'penalize_statistic_zhbb',
            name: '综合报表',
            alias: 'penalize_statistic_zhbb',
            path: '/query/zhbb',
            source: 'iconfont  ui-amy-detail',
            sort: 1,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1552225636968787970',
            parentId: '1552224318153781249',
            code: 'penalize_info_statistic',
            name: '一般行政处罚',
            alias: 'penalize_info_statistic',
            path: '/query/xzcf',
            source: 'iconfont  ui-amy-detail',
            sort: 1,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1552539820281446402',
            parentId: '1552224318153781249',
            code: 'penalize_query_arcf',
            name: '按日连续处罚',
            alias: 'penalize_query_arcf',
            path: '/query/arcf',
            source: 'iconfont  ui-lvyoudashujujianguan',
            sort: 2,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1552575278759690241',
            parentId: '1552224318153781249',
            code: 'penalize_query_cfky',
            name: '查封、扣押',
            alias: 'penalize_query_cfky',
            path: '/query/cfky',
            source: 'headfont  headfonthetongxinxi',
            sort: 3,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1553932268878684161',
            parentId: '1552224318153781249',
            code: 'penalize_query_xztc',
            name: '限制生产、停产案件',
            alias: 'penalize_query_xztc',
            path: '/query/xztc',
            source: 'iconfont  ui-amy-hand-stop-o',
            sort: 4,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1553942914181619714',
            parentId: '1552224318153781249',
            code: 'penalize_query_xzjl',
            name: '行政拘留环境违法',
            alias: 'penalize_query_xzjl',
            path: '/query/xzjl',
            source: 'iconfont  ui-amy-chain',
            sort: 5,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1553943274023542785',
            parentId: '1552224318153781249',
            code: 'penalize_query_sxfz',
            name: '涉嫌环境违法犯罪',
            alias: 'penalize_query_sxfz',
            path: '/query/sxfz',
            source: 'leftfont  leftfontshenhezhuanjiaguanli',
            sort: 6,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1553943640844787713',
            parentId: '1552224318153781249',
            code: 'penalize_query_qzxz',
            name: '申请法院强制执行',
            alias: 'penalize_query_qzxz',
            path: '/query/qzxz',
            source: 'leftfont  leftfontzhifaguanli',
            sort: 7,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          }
        ],
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1554400893129404418',
        parentId: '1555087252571807746',
        code: 'penalize_info_statistic',
        name: '信息统计',
        alias: 'penalize_info_statistic',
        path: '/',
        source: 'leftfont  leftfontjichuziliaoguanli',
        sort: 9,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        children: [
          {
            id: '1554401280847311745',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_ajzxqk',
            name: '案件执行情况',
            alias: 'penalize_statistic_ajzxqk',
            path: '/statistic/ajzxqk',
            source: 'iconfont  ui-amy-chart-line',
            sort: 1,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1554401280817311745',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_zxcftj',
            name: '一般行政处罚案件',
            alias: 'penalize_statistic_zxcftj',
            path: '/statistic/zxcftj',
            source: 'iconfont  ui-amy-chart-line',
            sort: 1,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1554488156412682242',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_ptbffb',
            name: '配套办法执行情况',
            alias: 'penalize_statistic_ptbffb',
            path: '/statistic/ptbffb',
            source: 'iconfont  ui-amy-puzzle',
            sort: 2,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1555209217374674945',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_ayzktj',
            name: '案源种类统计',
            alias: 'penalize_statistic_ayzktj',
            path: '/statistic/ayzktj',
            source: 'iconfont  ui-amy-earth',
            sort: 3,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1555209574075064322',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_ajblqk',
            name: '案件办理情况',
            alias: 'penalize_statistic_ajblqk',
            path: '/statistic/ajblqk',
            source: 'leftfont  leftfontxianzhuangpingjia',
            sort: 4,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1555209514075044322',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_hylxtj',
            name: '行业类型统计',
            alias: 'penalize_statistic_hylxtj',
            path: '/statistic/hylxtj',
            source: 'leftfont  leftfontxianzhuangpingjia',
            sort: 4,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          },
          {
            id: '1555209544075044322',
            parentId: '1554400893129404418',
            code: 'penalize_statistic_wflbtj',
            name: '违法类型案件统计',
            alias: 'penalize_statistic_wflbtj',
            path: '/statistic/wflbtj',
            source: 'leftfont  leftfontxianzhuangpingjia',
            sort: 4,
            category: 1,
            action: 0,
            isOpen: 1,
            remark: '',
            isDeleted: 0,
            hasChildren: false,
            parentName: '',
            categoryName: '',
            actionName: '',
            isOpenName: ''
          }
        ],
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      }
    ],
    hasChildren: false,
    parentName: '',
    categoryName: '',
    actionName: '',
    isOpenName: ''
  },
  {
    id: '1515087212571807746',
    parentId: '0',
    code: 'law_pre',
    name: '法律法规',
    alias: 'dc',
    path: '',
    source: 'leftfont  leftfonthuanjingjiance',
    sort: 50,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '法律法规',
    isDeleted: 0,
    children: [
      {
        id: '1443090154003718145',
        parentId: '1435814762800861186',
        code: 'regulation_calc_perform',
        name: '违法表现',
        alias: 'calc_perform',
        path: '/regulation/calc/perform',
        source: 'iconfont icon-caidanguanli',
        sort: 2
      }
    ]
  },
  {
    id: '1435814762800861186',
    parentId: '0',
    code: 'discretionCounter',
    name: '自由裁量计算器',
    alias: 'menu',
    path: '/discretionCounter',
    source: 'iconfont iconicon_roundadd',
    sort: 51,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '',
    isDeleted: 0,
    children: [
      {
        id: '1443090154003718145',
        parentId: '1435814762800861186',
        code: 'regulation_calc_perform',
        name: '违法表现',
        alias: 'calc_perform',
        path: '/regulation/calc/perform',
        source: 'iconfont icon-caidanguanli',
        sort: 2,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1446361874605105153',
        parentId: '1435814762800861186',
        code: 'calc_list',
        name: '裁量历史记录',
        alias: 'calc_list',
        path: '/regulation/calc/list',
        source: 'iconfont iconicon_shakehands',
        sort: 3,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      }
    ],
    hasChildren: false,
    parentName: '',
    categoryName: '',
    actionName: '',
    isOpenName: ''
  },
  {
    id: '1555089561926230018',
    parentId: '0',
    code: '1',
    name: '案件审查',
    alias: '案件审查',
    path: '',
    source: 'leftfont  leftfonttzwj',
    sort: 60,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '环保部',
    isDeleted: 0,
    children: [
      {
        id: '1555089783733608449',
        parentId: '1555089561926230018',
        code: 'caseRegist-openCase',
        name: '案件受理',
        alias: 'menu',
        path: '/punish/transact/accept',
        source: 'leftfont  leftfontdxal',
        sort: 1,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1555090347787804674',
        parentId: '1555089561926230018',
        code: 'caseRegist-to-do-case',
        name: '待办案件',
        alias: 'menu',
        path: '/punish/transact/pending',
        source: 'leftfont  leftfontdabiaoguankongguanli',
        sort: 3,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1555090499898433538',
        parentId: '1555089561926230018',
        code: 'caseRegist-done-case',
        name: '已办案件',
        alias: 'menu',
        path: '/punish/transact/processed',
        source: 'leftfont  leftfontcuoshiqingdanguanli',
        sort: 4,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      }
    ],
    hasChildren: false,
    parentName: '',
    categoryName: '',
    actionName: '',
    isOpenName: ''
  },
  {
    id: '1123598815738675203',
    parentId: '0',
    code: 'system',
    name: '系统管理',
    alias: 'menu',
    path: '/system',
    source: 'iconfont iconicon_setting',
    sort: 99,
    category: 1,
    action: 0,
    isOpen: 1,
    remark: '',
    isDeleted: 0,
    children: [
      {
        id: '1123598815738675204',
        parentId: '1123598815738675203',
        code: 'user',
        name: '用户管理',
        alias: 'menu',
        path: '/system/user',
        source: 'iconfont iconicon_principal',
        sort: 1,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1123598815738675205',
        parentId: '1123598815738675203',
        code: 'dept',
        name: '机构管理',
        alias: 'menu',
        path: '/system/dept',
        source: 'iconfont iconicon_group',
        sort: 2,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1496759157674491905',
        parentId: '1123598815738675203',
        code: 'admin_role',
        name: '角色管理',
        alias: 'admin_role',
        path: '/authority/role',
        source: 'iconfont iconicon_boss',
        sort: 3,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1164733379658963251',
        parentId: '1123598815738675203',
        code: 'dictbiz',
        name: '业务字典',
        alias: 'menu',
        path: '/system/dictbiz',
        source: 'iconfont iconicon_study',
        sort: 5,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      },
      {
        id: '1496420060296671238',
        parentId: '1123598815738675203',
        code: 'param-biz-menu',
        name: '业务参数',
        alias: 'param-biz-menu',
        path: '/system/param-biz',
        source: 'iconfont icon-wxbgongju',
        sort: 8,
        category: 1,
        action: 0,
        isOpen: 1,
        remark: '',
        isDeleted: 0,
        hasChildren: false,
        parentName: '',
        categoryName: '',
        actionName: '',
        isOpenName: ''
      }
    ],
    hasChildren: false,
    parentName: '',
    categoryName: '',
    actionName: '',
    isOpenName: ''
  }
]

export const getRoutes = () => {
  return new Promise(resolve => {
    return resolve({
      code: 200,
      success: true,
      data: menus1,
      msg: '操作成功'
    })
  })
}

export default { getRoutes }
